// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BoUh","rootMobile":"styles_rootMobile__RPD_e"};